import { lazy } from "react";
import { BC_HQ, BC_REPORTS, PARTNERS } from "app_constants";

import { ICON_TYPE } from "components/icons/icon";
import {
  DateRangeSupport,
  QueryParamDateFormat,
  formatForQueryParams,
} from "helpers/shared/formatters/dates";

import { LD_FEATURE_FLAGS } from "types/context";
import type { ISectionProps } from "types/navigation";

const DAILY_REVIEW: ISectionProps = {
  feature: "Daily Review",
  icon: ICON_TYPE.DAILY_REVIEW,
  path: "/daily_review",
  level: ["store", "brand"],
  dateSupport: DateRangeSupport.NONE,
  subSections: [
    {
      feature: "Logbook",
      app: PARTNERS,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/daily_review/logbook",
      legacyPath: () => "/operations/logbook/today",
      dateSupport: DateRangeSupport.NONE,
    },
    {
      feature: "Shift Notes",
      app: BC_HQ,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/daily_review/shift_notes",
      legacyPath: () => "/shift_notes",
      dateSupport: DateRangeSupport.NONE,
    },
    {
      feature: "Preorders",
      app: BC_HQ,
      component: lazy(() => import("containers/olo/preorders_container")),
      requiresFeatureFlag: LD_FEATURE_FLAGS.preOrderView,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/daily_review/preorders",
      dateSupport: DateRangeSupport.NONE,
    },
    {
      feature: "Shift Prep",
      app: PARTNERS,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/daily_review/shift_prep",
      legacyPath: () => "/settings/location/shift_prep",
      dateSupport: DateRangeSupport.NONE,
    },
    {
      feature: "Pay In / Pay Out",
      app: BC_REPORTS,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/daily_review/pipo",
      legacyPath: ({ startDate, endDate }) => {
        return (
          "/reports/pipo" +
          "?startDate=" +
          formatForQueryParams(startDate, QueryParamDateFormat.BREADCRUMB) +
          "&endDate=" +
          formatForQueryParams(endDate, QueryParamDateFormat.BREADCRUMB)
        );
      },
      dateSupport: DateRangeSupport.FULL,
    },
    {
      feature: "Campaigns",
      app: PARTNERS,
      level: ["store", "brand"],
      scope: ["staff", "superuser"],
      path: "/daily_review/campaigns",
      legacyPath: () => "/marketing/campaigns",
      dateSupport: DateRangeSupport.NONE,
    },
  ],
};

export default DAILY_REVIEW;
